module.exports = __webpack_public_path__ + "static/img/555.fb01901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/555.png
// module id = YnB8
// module chunks = 0